import { useCallback, useLayoutEffect, useState } from "react";

export const useIsTruncated = <T extends HTMLElement = HTMLElement>(): {
  ref: (node: T | null) => void;
  isTruncated: boolean;
} => {
  const [node, setNode] = useState<T | null>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const measure = useCallback((): void => {
    if (node?.isConnected) {
      setIsTruncated(node.scrollWidth > node.clientWidth);
    }
  }, [node]);

  useLayoutEffect(measure);

  useLayoutEffect(() => {
    if (!node || typeof ResizeObserver === "undefined") {
      return;
    }

    const observer = new ResizeObserver(measure);
    observer.observe(node);
    return () => observer.disconnect();
  }, [node, measure]);

  return { ref: setNode, isTruncated };
};
